import { anatomyModule } from "./anatomy";
import { anatomy2Module } from "./anatomy2";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";
import { physiology2Module } from "./physiology2";
import { diseaseModule } from "./disease";
import { disease2Module } from "./disease2";
import { disease3Module } from "./disease3";
import { disease4Module } from "./disease4";
import { disease5Module } from "./disease5";
import { disease6Module } from "./disease6";
import { pharmacologyModule } from "./pharmacology";
import { pharmacology2Module } from "./pharmacology2";
import { surgeryModule } from "./surgery";
import { surgery2Module } from "./surgery2";

export const lungsModules = [
  anatomyModule,
  anatomy2Module,
  histologyModule,
  physiologyModule,
  physiology2Module,
  diseaseModule,
  disease2Module,
  disease3Module,
  disease4Module,
  disease5Module,
  disease6Module,
  pharmacologyModule,
  pharmacology2Module,
  surgeryModule,
  surgery2Module,
];
